module.exports = __webpack_public_path__ + "static/img/brees-2014-top-image.9839103.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/brees-2014-top-image.jpg
// module id = 4Hv4
// module chunks = 1